import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import {
  DEFAULT_VALUES,
  VALIDATE_KEY_VALUES
} from "./label-value-pair.constants";
import { throwErrorMessage } from "../../../helpers/kwikui.common.helpers";
import { isValidKeyValue } from "./label-value-pair.validation";

@Component({
  selector: "kwikui-label-value-pair",
  templateUrl: "./label-value-pair.component.html",
  styleUrls: ["./label-value-pair.component.scss"]
})
export class KwikUILabelValuePairComponent implements OnInit {
  @Input() config = DEFAULT_VALUES.config;

  @Input() data = DEFAULT_VALUES.data;

  @Input() id = DEFAULT_VALUES.id;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    const verifyChange = (key: string) => {
      return changes.hasOwnProperty(key) && !changes[key].firstChange;
    };

    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    if (verifyChange("config")) {
      this.config = changes.config.currentValue;
    }
    if (verifyChange("data")) {
      this.data = changes.data.currentValue;
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-label-value-pair",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }
}
